<template>
    <div>
        <div class="card">
			<GameNav v-if="isTablet" class="fields__item"/>
            <div class="card__body">
                <div class="coin-flip">
                    <div class="coin-flip__output">
						<div id="coin" :class="[drop]">
							<div class="coin-flip__side" :style="{backgroundImage: `url(/images/${side1}_w.png)`}"></div>
							<div class="coin-flip__side" :style="{backgroundImage: `url(/images/${side2}_w.png)`}"></div>
						</div>
                    </div>
                    <div class="coin-flip__input-area">
						<div class="coin-flip__steps">
							<div class="steps-slider">
								<svg class="steps-slider__arrow" @click="slidePrev">
									<use href="#svg-icon-slider-prev"></use>
								</svg>
								<swiper class="steps-slider__carousel"
										:slides-per-view="2"
										:space-between="0"
										@swiper="onSwiper"
										:grab-cursor="true"
								>
									<swiper-slide class="steps-slider__slide" v-for="(slide, key) in 20" :id="step">
										<div class="steps-slider__slide-inner" :class="[step === slide ? 'active' : '', step > slide ? 'success' : '', false ? 'danger' : '']">
											<span class="steps-slider__slide-label">{{ slide < slide + key -1 ? 'След.коэффициент':'Коэффициент' }}</span>
											<span class="steps-slider__slide-title">{{ Number(coefs[getStepCoef(1, slide)]) }}</span>
										</div>
									</swiper-slide>
								</swiper>
								<svg class="steps-slider__arrow" @click="slideNext">
									<use href="#svg-icon-slider-next"></use>
								</svg>
							</div>
						</div>
						<div class="coin-flip__game-controls game-controls">
							<div class="text-field__label">Сумма</div>
							<div class="game-controls__bet">
								<input placeholder="Сумма"
									   type="number"
									   autocomplete="off"
									   class="game-controls__input"
									   @keyup="validateBet"
									   v-model="bet"/>
							</div>
							<div class="game-controls__items">
								<button class="game-controls__item" @click="typeBet('max')" type="button">Max</button>
								<button class="game-controls__item" @click="typeBet('min')" type="button">Min</button>
								<button class="game-controls__item" @click="typeBet('x2')" type="button">x2</button>
								<button class="game-controls__item" @click="typeBet('/2')" type="button">/2</button>
							</div>
						</div>
						<div class="coin-flip__row" v-show="game">
							<div class="coin-flip__col">
								<button class="btn btn--primary btn--block btn--lg" @click="coinBet(0)" :disabled="disableBtnGame">
									W
								</button>
							</div>
							<div class="coin-flip__col">
								<button class="btn btn--primary-alt btn--block btn--lg" @click="coinBet(1)" :disabled="disableBtnGame">
									N
								</button>
							</div>
						</div>
						<button v-if="!game" class="coin-flip__field btn btn--primary btn--block btn--lg" @click="startCoin" :disabled="disableBtn">
							Начать играть
						</button>
						<button v-if="game" class="coin-flip__field btn btn--success btn--block btn--lg" @click="finishCoin" :disabled="disableBtn || !step">
							Забрать {{ win }}
						</button>
						<button class="btn btn--block btn--danger" v-if="errors.show">
							{{ errors.message }}
						</button>
                    </div>
                </div>
            </div>
			<AllHistory />
        </div>
    </div>
</template>

<script>
    import AllHistory from "../../components/History/AllHistory.vue";
	import { mapState } from 'pinia';
	import { useUserStore } from '../../stores/User';
	import { Swiper, SwiperSlide } from 'swiper/vue';
	import breakpointsMixin from "../../mixins/breakpoints-mixin.vue";
	import GameNav from "../../components/blocks/GameNav.vue";

    export default {
        components: {
            AllHistory,
			Swiper,
			SwiperSlide,
			GameNav
        },
		mixins: [
			breakpointsMixin
		],
        data() {
            return {
                currentStepX: 1,
                slideStep: 1,
                game: false,
                bet: 1,
                coef: 1.8,
                win: 0,
                step: 0,
                drop: 'noDrop',
                nextcoef: 3.6,
                errors: {
                    show: false,
                    message: ''
                },
                disableBtn: false,
                disableBtnGame: false,
                currentStep: 1,
                side1: 'head',
                side2: 'tail',
                coefs: [],
				swiper: null
            }
        },
        mounted() {
            this.$root.isLoading = true;

            if (this.$cookie.get('token')) {
                this.getGame();
            } else {
                this.$root.isLoading = false;
            }
            var coefs = [];
            coefs[coefs.length] = 0;
            var k = 1
            for (var i = 1; i < 41; i++) {
                coefs.push((1.8 * k).toFixed(2))
                k=k*2
            }
            this.coefs = coefs
        },

		watch: {
			step() {
				this.scrollToActiveStep();
			}
		},
		computed: {
			...mapState(useUserStore, ['user'])
		},
        methods: {
            getStepCoef(type, step) {
                if (type == 1) {
                    return step * 2 - 1
                } else {
                    return step * 2
                }
            },
            startCoin() {
                this.disableBtn = true;
                this.drop = 'noDrop';
                this.errors = {
                    show: false,
                    message: ''
                };

                if (! this.$cookie.get('token')) {
                    this.errors = {
                        show: true,
                        message: 'Авторизуйтесь'
                    };

                    this.disableBtn = false;

                    return;
                }

                this.bet = this.bet.toString();

                this.bet = this.bet.replace(/[,]/g, '.').replace(/[^\d,.]*/g, '').replace(/([,.])[,.]+/g, '$1').replace(/^[^\d]*(\d+([.,]\d{0,2})?).*$/g, '$1');
                this.bet = parseInt(this.bet, 10);

				this.$root.axios.post('/api/game/coin/start', {
                    bet: this.bet
                }).then(res => {
                    const data = res.data;

                    this.coef = 1.8;
                    this.nextcoef = 3.6;
                    this.game = true;
                    this.step = 0;
                    this.win = Number(data.bet).toFixed(2);
                    this.user.balance = data.balance;

                    this.disableBtn = false;
                }).catch(error => {
                    this.errors = {
                        show: true,
                        message: this.$root.graphql.axiosGetError(error)
                    };

                    this.disableBtn = false;
                });
            },
            finishCoin() {
                this.disableBtn = true;
                this.drop = 'noDrop';
                this.errors = {
                    show: false,
                    message: ''
                };
                this.bet = parseInt(this.bet, 10);

				this.$root.axios.post('/api/game/coin/finish').then(res => {
                    const data = res.data;

                    this.user.balance = data.balance;
                    this.game = false;
                    this.win = 0;

                    this.disableBtn = false;
                }).catch(error => {
                    this.errors = {
                        show: true,
                        message: this.$root.graphql.axiosGetError(error)
                    };

                    this.disableBtn = false;
                });
                
            },
            getGame() {
                this.axios.get('/api/game/coin/info')
                .then(res => {
                    const data = res.data;

                    if(data.success) {
                        let coef = !data.step ? 1 : data.coef;
                        this.game = true;
                        this.bet = data.bet;
                        this.win = Number(coef * data.bet).toFixed(2);
                        this.coef = data.coef;
                        this.nextcoef = data.nextcoef;
                        this.step = data.step;
                    }
                }).catch(error => {
                    this.errors = {
                        show: true,
                        message: this.$root.graphql.axiosGetError(error)
                    };
                });

                this.$root.isLoading = false;
            },
            getSides() {
                var t, e;
                return 1 === this.currentStep - 1 
                    ? (t = "tail", e = "head")
                    : 0 === this.currentStep - 1 && (t = "head", e = "tail"), [t, e]
            },
            coinBet(type) {
                if (this.disableBtnGame) {
                    return;
                }

                this.disableBtnGame = true;

                //this.drop = 'noDrop';
                this.errors = {
                    show: false,
                    message: ''
                };

                this.$root.axios.post('/api/game/coin/choose', {
                    side: type
                }).then(res => {
                    const data = res.data;

                    this.disableBtn = true;
                    this.currentStep = (data.drop == 1) ? 1 : 2;

                    var t = this,
                        e = document.querySelector('#coin'),
                        o = this.getSides(),
                        //n = O()(o, 2),
                        r = o[0],
                        l = o[1];
                    e.classList.add("animate"), setTimeout((function() {
                        t.side1 = r, t.side2 = l
                    }), 300);

                    e.addEventListener("animationend", (function o() {
                        e.classList.remove("animate"), e.removeEventListener("animationend", o)
                        t.disableBtn = false;
                        t.win = Number(data.bet * data.coef).toFixed(2);
                        t.coef = data.coef;
                        t.nextcoef = data.nextcoef;
                        t.step++;
                        if(data.nextcoef == 0) {
                            t.game = false;
                            t.coef = 1;
                            t.nextcoef = 1.8;
                            t.step = 0;
                        }
                        t.disableBtnGame = false;
                    }))
                }).catch(error => {
                    this.errors = {
                        show: true,
                        message: this.$root.graphql.axiosGetError(error)
                    };
                });
            },
			slidePrev() {
				this.swiper.slidePrev();
			},

			slideNext() {
				this.swiper.slideNext();
			},

			onSwiper(inst) {
				this.swiper = inst;
			},
			async scrollToActiveStep() {
				setTimeout(() => {
					this.swiper.slideTo(this.step - 1);
				},1)

			},
            typeBet(type) {
                switch (type) {
                    case "max":
                        if (this.user !== null) {
                            this.bet = this.user.balance;
                        } else {
                            this.bet = 0;
                        }
                        break;
                    case "min":
                        this.bet = 1;
                        break;
                    case "x2":
						this.bet = this?.user?.balance && this.bet * 2 > +this.user.balance ? this.user.balance : +(this.bet * 2).toFixed(2);
                        break;
                    case "/2":
                        this.bet = (this.bet / 2).toFixed(2);
                        break;
                }
                this.validateBet();
            },
            validateBet() {
                if(Number(this.bet) && this.bet < 1) {
                    this.bet = 1;
                }
				if (this.bet > 1000000) {
					this.bet = 1000000;
				}
				if (this?.user?.balance && this.bet > +this.user.balance) {
					this.bet = +this.user.balance
				}
            }
        }
    }
</script>